import React from "react";
import { useState, useEffect } from "react";
import { ChevronDown, Eye, EyeOff, HelpCircle, Globe } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../assets/images/logo.png";
import { useTranslation } from "react-i18next";
import styles from "../../styles/__header.module.scss";

const Header = ({ changeLanguage, hideLanguage = false }) => {
  const { t, i18n } = useTranslation();
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const location = useLocation();
  // Hide the language switcher on the login page or when explicitly requested.
  const isLoginPage = location.pathname === "/";

  const languages = [
    { code: "en", name: "English", flag: "🇺🇸" },
    { code: "ar", name: "العربية", flag: "🇸🇦" },
    // { code: "ku", name: "کوردی", flag: "🇮🇶" },
    // { code: "tr", name: "Türkçe", flag: "🇹🇷" },
    // { code: "fa", name: "فارسی", flag: "🇮🇷" },
  ];

  // Get the current language name based on i18n.language
  const getCurrentLanguageName = () => {
    const currentLang = languages.find((lang) => lang.code === i18n.language);
    return currentLang ? currentLang.name : "English";
  };

  const [selectedLanguage, setSelectedLanguage] = useState(
    getCurrentLanguageName(),
  );

  // Sync selectedLanguage with i18n.language whenever it changes
  useEffect(() => {
    setSelectedLanguage(getCurrentLanguageName());
  }, [i18n.language]);

  const handleLanguageSelect = (language) => {
    setSelectedLanguage(language.name);
    changeLanguage(language.code);
    setShowLanguageDropdown(false);
  };

  return (
    <header className={styles["header"]}>
      <div className={styles["logo-section"]}>
        <div className={styles["logo"]}>
          <Link to="/">
            <img src={Logo} alt="Logo" />
          </Link>
        </div>
        {/* <div className={styles["brand-text"]}>
            <h1>TIRYAQ</h1>
            <p>ELECTRONIC HEALTH PLATFORM</p>
          </div> */}
      </div>
      <div className={styles["header-actions"]}>
        <a
          href="https://tiryaqapp.com/"
          target="_blank"
          rel="noopener noreferrer"
          className={styles["help-btn"]}
        >
          <HelpCircle size={16} />
          {t("header.text")}
        </a>
        {!isLoginPage && !hideLanguage && (
          <div className={styles["language-dropdown-container"]}>
            <button
              className={styles["language-btn"]}
              onClick={() => setShowLanguageDropdown(!showLanguageDropdown)}
            >
              <Globe size={16} />
              {selectedLanguage}
              <ChevronDown
                size={16}
                className={showLanguageDropdown ? styles["rotated"] : ""}
              />
            </button>
            {showLanguageDropdown && (
              <div className={styles["language-dropdown"]}>
                {languages.map((language) => (
                  <button
                    key={language.code}
                    className={`${styles["language-option"]} ${selectedLanguage === language.name ? styles["selected"] : ""}`}
                    onClick={() => handleLanguageSelect(language)}
                  >
                    <span className={styles["language-flag"]}>
                      {language.flag}
                    </span>
                    <span className={styles["language-name"]}>
                      {language.name}
                    </span>
                  </button>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
